import { time } from "framer-motion";
import { SectorConfig } from "../types/sectors";

// Updated mock sector configurations based on the provided image
export const mockSectors: SectorConfig[] = [
  { id: "FMCG", name: "FMCG", color: "#6E59A5" },
  { id: "IT", name: "IT", color: "#fb923c" },
  { id: "CONSURDURBL", name: "Consumer Durables", color: "#1EAEDB" },
  { id: "ENERGY", name: "Energy", color: "#ec4899" },
  { id: "PVTBANK", name: "Private Bank", color: "#a78bfa" },
  { id: "PSUBANK", name: "PSU Bank", color: "#f97316" },
  { id: "FINSERVICE", name: "Financial Service", color: "#0ea5e9" },
  { id: "AUTO", name: "Auto", color: "#ea384c" },
  { id: "PHARMA", name: "Pharma", color: "#fbbf24" },
  { id: "HEALTHCARE", name: "Healthcare", color: "#4ade80" },
  { id: "CONSUMPTION", name: "Consumption", color: "#d946ef" },
  { id: "OILANDGAS", name: "Oil and Gas", color: "#9b87f5" },
  { id: "METAL", name: "Metal", color: "#9b87f5" },
  { id: "COMMODITIES", name: "Commodities", color: "#8B5CF6" },
  { id: "INFRA", name: "Infrastructure", color: "#60a5fa" },
  { id: "MEDIA", name: "Media", color: "#6E59A5" },
  { id: "REALTY", name: "Realty", color: "#9b87f5" },
  // { id: "DEFENCE", name: "DEFENCE", color: "#fb923c" },
];

export const generateTimePoints = () => {
  const times = [];
  let h = 9, m = 15;
  while (h < 15 || (h === 15 && m <= 30)) {
    times.push(`${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`);
    m++;
    if (m === 60) { h++; m = 0; }
  }
  return times;
};
export const getTimePoints = () => {
  const lsmData = sessionStorage.getItem("lsm")
  if (lsmData) {

    let times = Object.keys(JSON.parse(lsmData));

    // Convert and sort times as time values
    times.sort((a, b) => {
      let [h1, m1] = a.split(':').map(Number);
      let [h2, m2] = b.split(':').map(Number);
      return h1 * 60 + m1 - (h2 * 60 + m2);
    });

    // Filter times between 9:15 AM (555 mins) and 3:30 PM (930 mins)
    let filteredTimes = times.filter(time => {
      let [h, m] = time.split(':').map(Number);
      let totalMinutes = h * 60 + m;
      return totalMinutes >= 555 && totalMinutes <= 930;
    });
    return filteredTimes
  }
  return []
}
export const generateMockMinuteData = () => {
  const times = generateTimePoints();
  const mock = mockSectors.map(sector => {
    // Base value different for each sector to create more varied chart
    let last = 1000 + Math.random() * 200;
    // Create different trends for different sectors to make it look more realistic
    const trendFactor = Math.random() * 2 - 1; // between -1 and 1
    const volatility = Math.random() * 0.8 + 0.2; // between 0.2 and 1.0
    // Generate sector-specific patterns
    const data = times.map((time, index) => {
      // Morning momentum (first hour)
      let timeFactor = 1;
      const [hour, minute] = time.split(':').map(Number);
      // Morning trend
      if (hour < 11) {
        timeFactor = 1.2;
      }
      // Lunch hour lull
      else if (hour >= 12 && hour < 13) {
        timeFactor = 0.7;
      }
      // Afternoon volatility 
      else if (hour >= 14) {
        timeFactor = 1.5;
      }
      // Calculate movement based on all factors
      const randomMove = (Math.random() - 0.5) * volatility * timeFactor;
      const trendMove = (trendFactor * 0.1) * (index / times.length) * timeFactor;
      last += randomMove + trendMove;
      return { value: last };
    });
    return { ...sector, data };
  });
  return mock
};
export const getMinuteData = () => {
  const times = getTimePoints();
  const lsmData = JSON.parse(sessionStorage.getItem("lsm"))
  if (lsmData) {

    const mock = mockSectors.map(sector => {
      const data = times.map((time, index) => {
        return { value: lsmData[time][sector.id] };
      });
      return { ...sector, data };
    });

    return mock
  }
  return {}
};
export const formatTime = (time: string | undefined): string => {
  if (!time) return "--:--";
  const [h, m] = time.split(":");
  const hour = parseInt(h);
  return `${hour % 12 || 12}:${m} ${hour >= 12 ? 'PM' : 'AM'}`;
};

export const formatAxisTime = (time: string, index: number, totalPoints: number): string => {
  const [h, m] = time.split(':').map(Number);

  // Always show end point
  if (index === totalPoints - 1) {
    return formatTime(time);
  }

  // Skip 9:15 AM specifically
  if (h === 9 && m === 15) {
    return '';
  }

  // Show timestamps at 30-minute intervals (when minute is exactly 0 or 30)
  if (m === 0 || m === 30) {
    return formatTime(time);
  }

  // Hide all other time labels
  return '';
};
